import { useSyncExternalStore } from "react";

import { isServerReachable, subscribeToReachability } from "../../offline/connectivity";

function subscribe(callback: () => void) {
  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  const unsubscribe = subscribeToReachability(callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
    unsubscribe();
  };
}

export function useOnlineStatus(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine && isServerReachable(),
    () => true
  );
}
